import React from "react";

// Carte de section : titre (h2), actions à droite, corps. `intro` : phrase
// d'explication sous le titre, utile pour un public peu familier du numérique.
const FicheSection = ({ id, title, intro = null, actions = null, children, className = "" }) => {
  const titleId = id ? `${id}-title` : undefined;
  return (
    <section id={id} className={`fiche-section list-card ${className}`.trim()} aria-labelledby={titleId}>
      {(title || actions) && (
        <header className="fiche-section__header">
          {title && (
            <h2 className="fiche-section__title" id={titleId}>
              {title}
            </h2>
          )}
          {actions && <div className="fiche-section__actions">{actions}</div>}
        </header>
      )}
      {intro && <p className="fiche-section__intro">{intro}</p>}
      <div className="fiche-section__body">{children}</div>
    </section>
  );
};

export default FicheSection;
